import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogService } from '../../logging/log.service';
import { NavigationService } from '../../navigation/navigation.service';
import { LocationContextService } from '../location-context.service';

@Component({
    selector: 'app-centerline-selection',
    templateUrl: './centerline-selection.component.html'
})
export class CenterlineSelectionComponent implements OnInit, OnDestroy {
    LOG_SOURCE = 'CenterlineSelectionComponent';
    sub: Subscription;
    selectedTerminal: string;
    selectedCenterlineGroup: string;
    centerlines: string[];
    backButtonAvailable: boolean;

    constructor(
        private readonly locationContextService: LocationContextService,
        private readonly navigationService: NavigationService,
        private readonly logService: LogService
    ) {}

    ngOnInit() {
        this.locationContextService.clearSelectedCenterline();

        if (!this.locationContextService.isTerminalSelected()) {
            this.navigationService.redirectToTerminalSelection();
        } else if (!this.locationContextService.isCenterlineGroupSelected()) {
            this.navigationService.redirectToCenterlineGroupSelection();
        } else {
            this.backButtonAvailable = this.isBackButtonAvailable();
            this.selectedTerminal = this.locationContextService.getSelectedTerminal();
            this.selectedCenterlineGroup = this.locationContextService.getSelectedCenterlineGroup();

            this.locationContextService.requestCenterlines(this.locationContextService.getSelectedCenterlineGroup());

            this.sub = this.locationContextService.getCenterlines().subscribe(centerlines => {
                this.navigationService.setCenterlineOptionsCount(centerlines.length);

                // Redirect automatically if only 1 centerline is available
                if (centerlines.length === 1) {
                    const centerline = centerlines[0];

                    this.logService.info(
                        this.LOG_SOURCE,
                        `Centerline '${centerline}' is selected automatically because it is the only available option`,
                        { centerline }
                    );

                    this.setSelectedCenterlineAndRedirect(centerline, true);
                } else {
                    this.centerlines = centerlines;
                }
            });
        }
    }

    setSelectedCenterlineAndRedirect(centerline: string, singleCenterline: boolean) {
        this.logService.info(this.LOG_SOURCE, `Selected centerline '${centerline}'`, {
            centerline
        });
        this.locationContextService.setSelectedCenterline(centerline, singleCenterline);
        this.navigationService.redirectToHome();
    }

    isSingleTerminal() {
        return this.locationContextService.isSingleTerminal();
    }

    isSingleCenterlineGroup() {
        return this.locationContextService.isSingleCenterlineGroup();
    }

    isBackButtonAvailable(): boolean {
        if (this.navigationService.getCenterlineGroupOptionsCount() > 1) {
            return true;
        }
        if (this.navigationService.getTerminalOptionsCount() > 1) {
            return true;
        }
        return false;
    }

    redirectBack() {
        if (this.navigationService.getCenterlineGroupOptionsCount() > 1) {
            this.logService.info(this.LOG_SOURCE, 'Resetting location context data', {});
            this.locationContextService.resetLocationContextData();
            this.logService.info(this.LOG_SOURCE, 'Redirecting user back to centerline group selection', {});
            this.navigationService.redirectToCenterlineGroupSelection();
        } else if (this.navigationService.getTerminalOptionsCount() > 1) {
            this.logService.info(this.LOG_SOURCE, 'Resetting location context data', {});
            this.locationContextService.resetLocationContextData();
            this.logService.info(this.LOG_SOURCE, 'Redirecting user back to terminal selection', {});
            this.navigationService.redirectToTerminalSelection();
        }
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
